export default __webpack_public_path__ + "static/media/metamask.042980e9.svg";